import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import DropDownFolder from "./DropDownFolder";
import { CONSTANTS, NOTIFY } from "../../based/Constants";
import { Notify } from "../../based/Notify";
import Request from "../../based/Request";
import ArtistServices from "../../based/services/ArtistServices";
import MultipleImages from "../../based/MultipleImages";
import DropDownCustom from "./DropDownCustom";

const JOB_SEX = {
    NONE: 0,
    MAN: 1,
    WOMAN: 2,
};

const dataSex = [
    { value: JOB_SEX.MAN, label: "Nam" },
    { value: JOB_SEX.WOMAN, label: "Nữ" },
];

const modelArtwork = {
    name: "",
    id: 0,
    url: "",
    isDelete: false,
    sex: 0,
    appProductColor: null,
    appProductId: 0,
    folderId: 0,
};

function ModalAddArtwork({ setIsModal, isModal, getDataFolder, folderId, dataArt, setDataArt }) {
    const [dataArtwork, setDataArtwork] = useState([...dataArt]);
    const [productDropDown, setProductDropDown] = useState([]);

    useEffect(() => {
        setDataArtwork([...dataArt]);
        getProductDropDown();
    }, [dataArt]);

    function handleChange(value) {
        let data = [];
        let dt = [...dataArtwork];
        if (value && value.length > 0) {
            value.map((img) => {
                var existed = dt.find((x) => x.url == img);
                if (!existed) {
                    var item = {
                        ...modelArtwork,
                        url: img,
                        thumbnail: img,
                    };
                    data.push(item);
                }
            });
        }
        setDataArtwork([...dt, ...data]);
    }

    const getProductDropDown = async () => {
        let [err, data] = await ArtistServices.GetProductRender();
        if (!err && data) {
            setProductDropDown(data);
        } else {
            setProductDropDown([]);
        }
    };

    const removeItem = (idx) => {
        // let newData = [...dataArtwork];
        // let newData= dataArtwork.filter((data,index) => index !== idx)
        // setDataArtwork(newData);
        setDataArtwork((prevData) => prevData.filter((data, index) => index !== idx));
    };

    const isValid = () => {
        let check = true;
        if (dataArtwork.length > 0 && dataArtwork.some((item) => item.name == "")) check = false;
        if (dataArtwork.length == 0) check = false;
        return check;
    };

    const handleUploadArtwork = async () => {
        if (isValid()) {
            const model = [];
            dataArtwork.forEach((item) => {
                model.push({
                    model: {
                        id: item.id,
                        name: item.name,
                        url: item.url,
                        thumbnail: item.thumbnail,
                        isDelete: item.isDelete,
                        sex: item.sex,
                        appProductColor: item.appProductColor ? item.appProductColor : null,
                        appProductId: item.appProductId,
                        printSide: item.printSide,
                    },
                    folderId: item.folderId,
                });
            });
            let [err, data] = await ArtistServices.CreateArtworkAndFolderConnection(model);
            if (!err && data == 1) {
                getDataFolder();
                setDataArt([]);
                setIsModal(false);
                Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Thành công");
            } else {
                if (data == -2) {
                    Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Đã tồn tại");
                } else {
                    Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Thất bại");
                }
            }
        }
        if (dataArtwork.length > 0 && dataArtwork.some((item) => item.name == "")) {
            Notify(NOTIFY.WARNING, NOTIFY.WARNING, "Nhập đầy đủ tên của các artwork");
        }
        if (dataArtwork.length == 0) {
            Notify(NOTIFY.WARNING, NOTIFY.WARNING, "Chưa thêm artwork nào");
        }
    };

    return (
        <StyleModal
            className={`${isModal ? "show" : ""}`}
            onClick={() => {
                setIsModal(false);
                setDataArt([]);
            }}
        >
            <div
                className={`modal-art`}
                onClick={(e) => {
                    e.stopPropagation();
                }}
            >
                <div className="modal-art-header">
                    <h3>Đăng tải artwork</h3>
                    <div
                        className="close-art"
                        onClick={() => {
                            setIsModal(false);
                            setDataArt([]);
                        }}
                    >
                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 1L1 14" stroke="white" stroke-width="2" stroke-linecap="round" />
                            <path d="M14 14L1 0.999999" stroke="white" stroke-width="2" stroke-linecap="round" />
                        </svg>
                    </div>
                </div>
                <div className="modal-art-body">
                    <div className="group-box-add">
                        <MultipleImages className="hide" id="art-work-modal" name="art-modal" size={20} images={[]} onChanged={(key, value) => handleChange(value)} />
                        <label for="art-work-modal" className="add-name">
                            Tải lên +
                        </label>
                        <span className="desc-add">Yêu cầu hình dưới 20Mb, định dạng .PNG, .JPG, .SVG</span>
                    </div>
                    <div className="list-art-modal">
                        {dataArtwork &&
                            dataArtwork.length > 0 &&
                            dataArtwork.map((item, idx, arr) => {
                                return (
                                    <ArtworkItem
                                        productDropDown={productDropDown}
                                        lastIndex={arr.length - 1}
                                        last={arr.length > 2 && arr.length - 1 === idx ? true : false}
                                        folderId={folderId}
                                        item={item}
                                        idx={idx}
                                        removeItem={removeItem}
                                        dataArtwork={dataArtwork}
                                        setDataArtwork={setDataArtwork}
                                    />
                                );
                            })}
                    </div>
                </div>
                <div className="modal-art-footer">
                    <button
                        onClick={() => {
                            handleUploadArtwork();
                        }}
                    >
                        Đăng tải
                    </button>
                </div>
            </div>
        </StyleModal>
    );
}

function ArtworkItem({ idx, item, removeItem, setDataArtwork, dataArtwork, folderId, last, lastIndex, productDropDown }) {
    const [selectedItem, setSelectedItem] = useState({});
    const [name, setName] = useState("");
    const [selectedProduct, setSelectedProduct] = useState({});
    const [selectedColor, setSelectedColor] = useState({});
    const [selectedSex, setSelectedSex] = useState({});
    const [selectedPrintSide, setSelectedPrintSide] = useState({});

    useEffect(() => {
        let newData = [...dataArtwork];
        newData[idx] = {
            ...dataArtwork[idx],
            name: name,
            folderId: selectedItem.id,
            sex: selectedSex.sex,
            appProductColor: selectedColor.colorCode,
            appProductId: selectedProduct.productId,
            printSide: selectedPrintSide.printSide,
        };
        setDataArtwork(newData);
    }, [name, selectedItem, selectedSex, selectedColor, selectedProduct]);

    const getSexRender = async (productId,color) => {
        let [err, data] = await ArtistServices.GetSexRender({
            productId, color
        })
        if(!err && data && data.length > 0){
            setSelectedColor(prevState => ({
                ...prevState,
                sexs: data
            }));
            setSelectedSex(data[0])
            if(data[0].printSides && data[0].printSides.length > 0)
                setSelectedPrintSide(data[0].printSides[0])

        }
    }
  

    return (
        <div key={idx} className="col-art-modal">
            <div className="item-art-modal">
                <div className="item-art-left">
                    <div className="item-art-top">
                        <div className="col-image">
                            <img src={item.url} />
                        </div>
                        <div className="col-box">
                            <textarea
                                className="name-art"
                                maxLength={120}
                                value={name}
                                onChange={(e) => {
                                    setName(e.target.value);
                                }}
                                id={`name-art-${idx}`}
                                placeholder="Nhập tên artwork"
                                onClick={() => {
                                    let lastItem = document.getElementById(`name-art-${lastIndex}`);
                                    lastItem.click();

                                    setTimeout(() => {
                                        let currentItem = document.getElementById(`name-art-${idx}`);
                                        currentItem.focus();
                                    }, 500);
                                }}
                            ></textarea>
                        </div>
                    </div>
                    <div className="action-item-art">
                        <div className="dropdown-box">
                            <DropDownFolder last={last} selectedItem={selectedItem} setSelectedItem={setSelectedItem} folderId={folderId} />
                        </div>
                        <div
                            className="remove"
                            onClick={() => {
                                removeItem(idx);
                            }}
                        >
                            <svg width="19" height="22" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M12.7964 20.5991H5.90007C4.62971 20.5991 3.63156 19.6917 3.45008 18.4214L1.99823 5.62695H16.7889L15.2464 18.4214C15.0649 19.6917 14.0667 20.5991 12.7964 20.5991Z"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-miterlimit="10"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path d="M1 3.17773H17.5148" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" />
                                <path d="M6.35382 1H12.1612" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" />
                                <path d="M6.89813 9.34766L7.35184 15.518" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M11.889 9.34766L11.3445 15.518" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>
                </div>
                <div className="item-art-right">
                    <div className="action-art-video">
                        <div className="box-flex-space">
                            <h6>Xuất video</h6>
                            <span
                                onClick={() => {
                                    setSelectedProduct({
                                        productId: 0,
                                    });
                                    setSelectedSex({
                                        sex: 0,
                                    });
                                    setSelectedColor({
                                        colorCode: null,
                                    });
                                    setSelectedPrintSide({
                                        printSide: 0,
                                    });
                                }}
                            >
                                Xóa lựa chọn
                            </span>
                        </div>
                        <div className="box-product">
                            {productDropDown && productDropDown.length > 0 &&
                            productDropDown.map((item, idx)=>{
                                return <div key={idx} className="col-product">
                                    <div className={`item-product ${item.productId == selectedProduct.productId ? "active" : ""}`}
                                    onClick={()=>{
                                        setSelectedProduct(item)        
                                        if(item.colors && item.colors.length > 0){
                                            setSelectedColor(item.colors[0])
                                            getSexRender(item.productId,item.colors[0].colorCode)

                                        }                             

                                    }}
                                >
                                    <img src={item.productAvatar} />
                                    <span>{item.productName}</span>
                                </div>
                                </div>
                            })}
                        </div>
                            



                        <div className="box-color">
                            <h4>{selectedColor && selectedColor.colorName}</h4>
                            <div className="color-list">
                                {selectedProduct && selectedProduct.colors && selectedProduct.colors.length > 0 &&
                                selectedProduct.colors.map((item, idx)=>{
                                    return <div key={idx} className={`item-color ${item.colorCode == selectedColor.colorCode ? "active" : ""}`}
                                        onClick={()=>{
                                            setSelectedColor(item)
                                            getSexRender(selectedProduct.productId ,item.colorCode)
                                        }}

                                    >
                                        <span style={{backgroundColor: item.colorCode}}></span>
                                    </div>
                                })}
                            </div>
                        </div>

                        <div className="box-sex-print-side">
                            {selectedColor && selectedColor.sexs && selectedColor.sexs.length > 0 ?
                                <div className="box-col-50 w-40">
                                    <h4>Giới tính</h4>
                                    {
                                        selectedColor.sexs.map((item, idx)=>{
                                            return <div key={idx} className={`item ${item.sex == selectedSex.sex ? "active" : ""}`}
                                                onClick={()=>{
                                                    setSelectedSex(item)
                                                    if(item.printSides && item.printSides.length > 0)
                                                        setSelectedPrintSide(item.printSides[0])
                                    
                                                }}
        
                                            >
                                               {item.sexName}
                                            </div>
                                        })
                                    }
                                </div>
                                : ""}


                            {selectedSex && selectedSex.printSides && selectedSex.printSides.length > 0 ?
                                <div className="box-col-50 w-60">
                                    <h4>Mặt in</h4>
                                    {
                                        selectedSex.printSides.map((item, idx)=>{
                                            return <div key={idx} className={`item ${item.printSide == selectedPrintSide.printSide ? "active" : ""}`}
                                                onClick={()=>{
                                                    setSelectedPrintSide(item)
                                                }}
        
                                            >
                                               {item.printSideName}
                                            </div>
                                        })
                                    }
                                </div>
                                : ""}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const StyleModal = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.7);
    display: grid;
    place-items: center;

    .hide {
        display: none;
    }
    .modal-art {
        width: 800px;
        max-width: 90%;
        background-color: #313131;
        border-radius: 10px;

        .modal-art-header {
            padding: 20px 20px 0;
            display: flex;
            align-items: center;
            justify-content: space-between;

            h3 {
                font-weight: 600;
                font-size: 16px;
                line-height: 20px;
                letter-spacing: -0.3px;
                color: #ffffff;
            }
            .close-art {
                cursor: pointer;
            }
        }

        .modal-art-body {
            padding: 20px 20px 0;

            .group-box-add {
                margin-bottom: 20px;
                display: flex;
                align-items: center;

                .add-name {
                    font-weight: 600;
                    font-size: 14px;
                    line-height: 18px;
                    letter-spacing: -0.3px;
                    color: #06f1b9;
                    border: 2px solid #06f1b9;
                    border-radius: 10px;
                    outline: none;
                    width: 140px;
                    height: 42px;
                    display: grid;
                    place-items: center;
                    background-color: transparent;
                    cursor: pointer;
                }

                .desc-add {
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 18px;
                    letter-spacing: -0.3px;
                    color: #686868;
                    margin-left: 20px;
                }
            }

            .list-art-modal {
                overflow-y: auto;
                max-height: 300px;
                min-height: 300px;
                display: flex;
                flex-wrap: wrap;
                margin: 0 -7px;
                scroll-behavior: smooth;

                ::-webkit-scrollbar {
                    width: 5px;
                }
                ::-webkit-scrollbar-thumb {
                    background: #06f1b9;
                    border-radius: 10px;
                }

                .col-art-modal {
                    width: 100%;
                    min-width: 100%;
                    max-width: 100%;
                    padding: 0 7px;

                    .item-art-modal {
                        width: 100%;
                        background: #3a3a3a;
                        border-radius: 5px;
                        padding: 9px;
                        margin-bottom: 15px;
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: space-between;

                        .item-art-left {
                            width: calc(50% - 6px);
                            min-width: calc(50% - 6px);
                            max-width: calc(50% - 6px);

                            .item-art-top {
                                display: flex;
                                width: 100%;
                                .col-image {
                                    width: 30%;
                                    min-width: 30%;
                                    max-width: 30%;

                                    img {
                                        width: 100%;
                                        aspect-ratio: 1/1;
                                        object-fit: contain;
                                        border-radius: 5px;
                                    }
                                }
                                .col-box {
                                    width: 70%;
                                    min-width: 70%;
                                    max-width: 70%;
                                    padding-left: 12px;
                                    .name-art {
                                        background: #464646;
                                        border-radius: 5px;
                                        font-weight: 400;
                                        font-size: 14px;
                                        line-height: 18px;
                                        letter-spacing: -0.3px;
                                        color: #ffffff;
                                        padding: 10px;
                                        height: 100%;
                                        border: none;
                                        outline: none;
                                        width: 100%;
                                    }
                                }
                            }
                            .action-item-art {
                                width: 100%;
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                margin-top: 16px;

                                .dropdown-box {
                                    width: 80%;
                                    height: 34px;
                                }
                                .remove {
                                    cursor: pointer;
                                }
                            }
                        }
                        .item-art-right {
                            width: calc(50% - 6px);
                            min-width: calc(50% - 6px);
                            max-width: calc(50% - 6px);

                            .action-art-video {
                                .box-flex-space {
                                    display: flex;
                                    align-items: center;
                                    justify-content: space-between;

                                    h6 {
                                        color: #fff;
                                        font-family: Lexend;
                                        font-size: 14px;
                                        font-style: normal;
                                        font-weight: 500;
                                        line-height: 1;
                                        letter-spacing: -0.3px;
                                        margin: 0;
                                    }

                                    span {
                                        color: #06f1b9;
                                        font-size: 14px;
                                        font-weight: 500;
                                        line-height: 1;
                                        cursor: pointer;
                                    }
                                }
                                .box-product{
                                    display: flex;
                                    flex-wrap: wrap;
                                    margin: 4px -4px 0; 


                                    .col-product{
                                        width: 16.666666%;
                                        min-width: 16.666666%;
                                        max-width: 16.666666%;
                                        margin-top: 8px;
                                        padding: 0 4px;
                                    }
                                    .item-product{
                                        width: 100%;
                                        cursor: pointer;

                                        &.active{
                                            border-radius: 6px;
                                            border: 1px solid #06F1B9;
                                            background: #003125;
                                        }

                                        img{
                                            width: 100%;
                                            aspect-ratio: 1/1;
                                            object-fit: contain;
                                            border-radius: 3px;
                                        }

                                        span{
                                            color: #06F1B9;
                                            display: block;
                                            width: 100%;
                                            text-align: center;
                                            margin-top: 4px;
                                            font-family: Lexend;
                                            font-size: 10px;
                                            font-style: normal;
                                            font-weight: 400;
                                            line-height: 1.2;
                                            letter-spacing: -0.3px;  
                                            overflow: hidden;
                                            display: -webkit-box;
                                            -webkit-line-clamp: 2;
                                            -webkit-box-orient: vertical;
                                        }
                                    }
                                }

                                .box-color{
                                    margin-top: 12px;

                                    h4{
                                        margin: 0;
                                        color: #767676;
                                        font-family: Lexend;
                                        font-size: 14px;
                                        font-style: normal;
                                        font-weight: 400;
                                        line-height: 1;
                                        letter-spacing: -0.3px;
                                    }


                                    .color-list{
                                        display: flex;
                                        flex-wrap: wrap;

                                        .item-color{
                                            margin-top: 6px;
                                            margin-right: 6px;
                                            width: 38px;
                                            height: 38px;
                                            border-radius: 50%;
                                            cursor: pointer;
                                            
                                            span{
                                                display: block;
                                                width: 100%;
                                                height: 100%;
                                                border-radius: 50%;

                                            }

                                            &.active{
                                                padding: 3px;
                                                border: 1px solid #06F1B9;
                                            }

                                        }
                                    }

                                }

                                .box-sex-print-side{
                                    display: flex;
                                    align-items: start;


                                    .box-col-50{
                                        width: 50%;
                                        display: flex;
                                        flex-wrap: wrap;
                                        align-items: center;

                                        &.w-40{
                                            width: 40%;

                                        }
                                        &.w-60{
                                            width: 60%;

                                        }
    
                                        h4{
                                            margin: 16px 0 0 0;
                                            color: #767676;
                                            font-family: Lexend;
                                            font-size: 14px;
                                            font-style: normal;
                                            font-weight: 400;
                                            line-height: 1;
                                            letter-spacing: -0.3px;
                                            width: 100%;
                                        }

                                        .item{
                                            height: 38px;
                                            line-height: 38px;
                                            border-radius: 6px;
                                            background: #313131;
                                            color: #FFF;
                                            font-family: Lexend;
                                            font-size: 14px;
                                            font-style: normal;
                                            font-weight: 500;
                                            letter-spacing: -0.3px;
                                            padding: 0 12px;
                                            margin: 8px 8px 0 0;
                                            cursor: pointer;

                                            &.active{
                                                border: 1px solid #06F1B9;
                                                background: #003125;
                                            }

                                        }
                                    }
                                }
                              
                            }
                        }
                    }
                }
            }
        }

        .modal-art-footer {
            height: 78px;
            width: 100%;
            box-shadow: 0px -0.2px 1px #646464, 0px -2px 20px rgba(0, 0, 0, 0.15);
            display: grid;
            place-items: center;

            button {
                width: 144px;
                border: none;
                outline: none;
                background: linear-gradient(259.14deg, #06f1b9 1.32%, #008263 100%);
                border-radius: 10px;
                height: 46px;
                font-weight: 600;
                font-size: 16px;
                line-height: 20px;
                letter-spacing: -0.3px;
                color: #ffffff;
                display: grid;
                place-items: center;
            }
        }
    }

    @media only screen and (max-width: 768px) {
        transform: translateY(100%);
        transition: transform 0.2s;

        &.show {
            transform: translateY(0);
        }

        .modal-art {
            width: 100%;
            position: absolute;
            bottom: 0;
            max-width: 100%;
        

            &.keyboard {
                bottom: 1000px;
            }

            .modal-art-body {
                padding-top: 10px;

                .group-box-add {
                    margin-bottom: 10px;
                }
                .list-art-modal {
                    max-height: 320px;
                    min-height: 320px;
                    .col-art-modal {
                        width: 100%;
                        min-width: 100%;
                        max-width: 100%;

                        .item-art-modal {
                            .item-art-left {
                                width: 100%;
                                min-width: 100%;
                                max-width: 100%;
                            }
                            .item-art-right {
                                width: 100%;
                                min-width: 100%;
                                max-width: 100%;


                                .action-art-video {
                                    .box-flex-space {
                                        margin: 20px 0 0 0;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .modal-art-footer {
                padding: 16px;

                button {
                    width: 100%;
                }
            }
        }
    }
`;
export default ModalAddArtwork;



// WEBPACK FOOTER //
// ./src/artist-ui/components/ModalAddArtwork.js